import { Check, ChevronDown } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";

/**
 * Píldora compacta "Etiqueta: Valor ▾" que abre un menú de opciones.
 * Reemplaza filas de chips para reducir ruido visual.
 * opciones: [{ v, label, dot?: "rose"|"amber"|"emerald"|"fuchsia"|"sky" }]
 */
const DOT = { rose: "bg-rose-500", amber: "bg-amber-500", emerald: "bg-emerald-500", fuchsia: "bg-fuchsia-500", sky: "bg-sky-500", slate: "bg-slate-300" };

export default function FiltroMenu({ label, value, onChange, opciones, neutro, testid = "filtro" }) {
  const actual = opciones.find((o) => o.v === value) || opciones[0];
  const activo = neutro !== undefined ? value !== neutro : false;
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button type="button"
          className={`h-9 pl-3 pr-2 rounded-full border text-xs font-medium inline-flex items-center gap-1.5 transition-colors ${activo ? "border-primary/50 bg-primary/5 text-foreground" : "border-border text-muted-foreground hover:bg-accent"}`}
          data-testid={`${testid}-trigger`}>
          <span className="uppercase tracking-wider text-[10px] text-muted-foreground">{label}</span>
          {actual.dot && <span className={`w-1.5 h-1.5 rounded-full ${DOT[actual.dot]}`} />}
          <span className="font-semibold">{actual.label}</span>
          <ChevronDown className="w-3.5 h-3.5 opacity-60" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="min-w-[200px]">
        {opciones.map((o) => (
          <DropdownMenuItem key={o.v} onClick={() => onChange(o.v)} className="text-sm gap-2 cursor-pointer" data-testid={`${testid}-opcion-${o.v}`}>
            {o.dot ? <span className={`w-2 h-2 rounded-full ${DOT[o.dot]}`} /> : <span className="w-2" />}
            <span className="flex-1">{o.label}</span>
            {o.v === value && <Check className="w-4 h-4 text-primary" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
